import { GetterTree, MutationTree, ActionTree } from 'vuex'
import Vue from 'vue'
import * as T from '@/types'

import api from '@/api'
import crud from '@/store/store-crud'

import { mixin } from '@/store/utils'

const INITIAL_STATE: () => Partial<T.Store.TagsState> = () => ({

})

const getters: GetterTree<T.Store.TagsState, T.Store.RootState> = {
}

const mutations: MutationTree<T.Store.TagsState> = {
}

const actions: ActionTree<T.Store.TagsState, T.Store.RootState> = {
    async refresh ({ commit }, filters? : T.Filter[]) {
        const colors= [
            '#17809E', 
            '#366477',
            '#7D6EA6',
            '#976696',
            '#7D7932',
            '#B15858',
            '#647F41',
            '#438449',
            '#5B5B5B',
            '#986F33',
        ]

        commit('setLoading', true)
        try {
            const items: {[key: string]: any} = await api.tags.all(filters)
            Object.keys(items.items).forEach((tagKey: string, index: number) => {
                return items.items[tagKey].color = colors[index % colors.length]
            })
            commit('setItems', items)
        } catch (error) {
            console.log('Error refreshing tags: ', error)
        } finally {
            commit('setLoading', false)
        }
    },
}

const module = (mixin<T.Store.TagsState, T.Store.RootState>())(
    [crud<T.Tag>(api.tags)],
    {
        namespaced: true,
        state: INITIAL_STATE(),
        actions,
        getters,
        mutations,
    },
)

export default module
